import { useEffect, useState } from 'react';
import { useWPApi } from '@gik/core/api';

const PATH = 'employee';
const STAFF = 'staff';
const ADVISOR = 'advisor';

export interface Employee {
  id: number;
  name: string;
  title: string;
  titleAlt?: string;
  photo?: string;
  photoAlt?: string;
  order: number;
}

export interface WPEmployee {
  id: number;
  title: {
    rendered: string;
  };
  acf: {
    employee_type: string;
    photo_alt?: string;
    photo_main: string;
    title: string;
    title_copy_alt?: string;
    sort_order: number;
  };
}

export function useEmployees(initialEmployees?: WPEmployee[]): [Employee[], Employee[]] {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [advisors, setAdvisors] = useState<Employee[]>([]);
  const { data: wpResponse } = useWPApi<WPEmployee[]>(
    PATH,
    { initialData: initialEmployees },
    {
      searchParams: {
        per_page: 100,
        _fields: ['acf', 'title', 'id'],
      },
    }
  );

  const mapToEmployee = (employee: WPEmployee): Employee => ({
    id: employee.id,
    name: employee.title.rendered,
    title: employee.acf.title,
    titleAlt: employee.acf.title_copy_alt,
    photo: employee.acf.photo_main,
    photoAlt: employee.acf.photo_alt,
    order: employee.acf.sort_order,
  });

  useEffect(() => {
    if (wpResponse) {
      const sorted = wpResponse.sort((prev: WPEmployee, next: WPEmployee) => prev.acf.sort_order - next.acf.sort_order);
      setEmployees(sorted?.filter(employee => employee.acf.employee_type === STAFF).map(mapToEmployee));
      setAdvisors(sorted?.filter(employee => employee.acf.employee_type === ADVISOR).map(mapToEmployee));
    }
  }, [wpResponse]);

  return [employees, advisors];
}
